export function getCookie(cookieName: string, cookies = document.cookie) {
  const cookie = cookies.split('; ').find((c: string) => c.startsWith(cookieName));
  if (!cookie) return null;
  return cookie.split('=')[1];
}
